































import Toast from '@/shared/services/toast';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { AgentTableRow } from '../models/agentTableRow';
import { googleBmApi } from '../services/googlebmApi';

@Component({})
export default class GoogleBmVerificationModal extends Vue {
	@Getter public currentWorkspace: WorkspaceViewModel;

	@Prop() public item!: AgentTableRow;

	public loading: boolean = false;

	public async verifyItem() {
		if (this.loading || !this.item) {
			return;
		}
		this.loading = true;
		try {
			let result;
			if (this.isAgent) {
				result = await googleBmApi.requestAgentVerification(this.currentWorkspace.id, this.item.customAgentId);
			} else {
				result = await googleBmApi.requestLocationVerification(this.currentWorkspace.id, this.item.locationId);
			}
			this.item.verificationStatus = result.verificationState;
			Toast.showSuccess('Verification requested');
			this.$emit('verify', result.verificationState);
		} catch (e) {
			Toast.showError(`Verification request failed: ${e.message}`);
		}
		this.loading = false;
	}

	public get isAgent(): boolean {
		return this.item.rowType === 'agent';
	}
}
